import React, { useEffect, useState } from "react";

import { BiPlus } from "react-icons/bi";
import "./Order.css";
import axios from "axios";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
const OrderAddressDetails = ({ addNew, setAddNew }) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [addressList, setAddressList] = useState([]);
  const [prefiledData, setPreFillData] = useState();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    mobile: "",
    pincode: "",
    address: "",
    locality: "",
    city: "",
    state: "",
    landmark: "",
    altPhoneNumber: "",
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const [selectedAddress, setSelectedAddress] = useState("savedAddresses");

  // ------------------------
  const fetchAddressList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/FetchDeliveryAddressList`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const sortedData = data.sort((a, b) => (b?.IsDefault ? 1 : -1));
        setAddressList(sortedData);
        setLoading(false);
      })
      .catch((error) => {});
  };
  const fetchBillingList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/FetchBillingAddressList`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const sortedData = data.sort((a, b) => (b?.IsDefault ? 1 : -1));
        setAddressList(sortedData);
        setLoading(false);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchAddressList();
  }, []);
  useEffect(() => {
    if (selectedAddress == "savedInvoiceAddresses") {
      setLoading(true);
      fetchBillingList();
    }
  }, [selectedAddress]);

  const handleAddressChange = (e) => {
    setSelectedAddress(e.target.value);
    if (e?.target?.value === "savedAddresses") {
      setLoading(true);
      fetchAddressList();
    }
  };
  // --------------------------
  const validateAddress = () => {
    const phonePattern = /^\d{10}$/;
    const pincodePattern = /^\d{6}$/;

    if (!formData.mobile || !formData.mobile.match(phonePattern)) {
      toast.error("Please enter a valid mobile number");
      return false;
    }
    if (!formData.pincode.match(pincodePattern)) {
      toast.error("Please enter a valid 6-digit pincode");
      return false;
    }
    if (!formData?.address || formData?.address?.trim() === "") {
      toast.error("Please enter address");
      return false;
    }
    if (!formData?.locality || formData?.locality?.trim() === "") {
      toast.error("Please enter locality");
      return false;
    }
    if (!formData?.city || formData?.city?.trim() === "") {
      toast.error("Please enter city");
      return false;
    }
    if (!formData?.state || formData?.state?.trim() === "") {
      toast.error("Please enter state");
      return false;
    }
    return true;
  };
  const handleSaveAddress = () => {
    if (!validateAddress()) return;
    const data = {
      Id: prefiledData?.Id || null,
      PhoneNumber: formData.mobile,
      Pincode: formData.pincode,
      Locality: formData.locality,
      AreaAndStreet: formData.address,
      City: formData.city,
      State: formData.state,
      Landmark: formData.landmark,
      AltPhoneNumber: formData.altPhoneNumber,
      IsDefault: true,
      // userId:
    };
    const url =
      selectedAddress === "savedAddresses"
        ? `${Apiurl()}/api/Customer/AddUpdateDeliveryAddress`
        : selectedAddress === "savedInvoiceAddresses"
        ? `${Apiurl()}/api/Customer/AddUpdateBillingAddress`
        : null;
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      data: data,
      url: url,
    };
    axios(option)
      .then((e) => {
        if (selectedAddress === "savedAddresses") {
          fetchAddressList();
          setPreFillData();
        } else if (selectedAddress === "savedInvoiceAddresses") {
          fetchBillingList();
          setPreFillData();
        }
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setAddNew(false);
        setPreFillData();
      })
      .catch((error) => {});
  };
  const handleRemoveAddress = (item) => {
    const data = {
      Id: item?.Id,
    };
    const url =
      selectedAddress === "savedAddresses"
        ? `${Apiurl()}/api/Customer/RemoveDeliveryAddress`
        : selectedAddress === "savedInvoiceAddresses"
        ? `${Apiurl()}/api/Customer/RemoveBillingAddress`
        : null;
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },

      data: data,
      url: url,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e.data.message);

          if (selectedAddress === "savedAddresses") {
            fetchAddressList();
          } else if (selectedAddress === "savedInvoiceAddresses") {
            fetchBillingList();
          }
        }
        if (e?.data?.status == "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };

  const UpdateDefaultDeliveryAddress = (addressItem) => {
    const data = {};
    data.id = addressItem.Id;
    const url =
      selectedAddress === "savedAddresses"
        ? `${Apiurl()}/api/Customer/UpdateDefaultDeliveryAddress`
        : selectedAddress === "savedInvoiceAddresses"
        ? `${Apiurl()}/api/Customer/UpdateDefaultBillingAddress`
        : null;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: url,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e.data.message);
          if (selectedAddress === "savedAddresses") {
            fetchAddressList();
          } else if (selectedAddress === "savedInvoiceAddresses") {
            fetchBillingList();
          }
        }
        if (e?.data?.status == "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const handleEditAddress = (item) => {
    setPreFillData(item);
    setFormData({
      ...formData,

      mobile: item?.PhoneNumber,
      pincode: item?.Pincode,
      address: item?.AreaAndStreet,
      locality: item?.Locality,
      city: item?.City,
      state: item?.State,
      landmark: item?.Landmark,
      altPhoneNumber: item?.AltPhoneNumber,
    });
    setAddNew(true);
  };
  return (
    <div className="tab-content_data">
      <div id="address">
        <div className="row">
          <div className="col-lg-9">
            <h3>Saved Addresses</h3>
          </div>
          {selectedAddress === "savedInvoiceAddresses" &&
          addressList?.length ? null : !addNew ? (
            <div className="col-lg-3">
              <div className="order-filer-btn">
                <BiPlus className="add_butt_plus" />
                <input
                  type="button"
                  className="w-100 btn btn-default"
                  value="ADD NEW ADDRESS"
                  onClick={() => {
                    setFormData({
                      ...formData,
                      mobile: "",
                      pincode: "",
                      address: "",
                      locality: "",
                      city: "",
                      state: "",
                      landmark: "",
                      altPhoneNumber: "",
                    });
                    setAddNew(true);
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>

        {addNew ? (
          <>
            <div className="row">
              <div className=" col-lg-6">
                <label htmlFor="mobile" className="required-label">
                  10-digit Mobile Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mobile"
                  placeholder="Enter your mobile number"
                  maxLength="10"
                  required
                  value={formData.mobile}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="pincode">Pincode</label>
                <input
                  type="text"
                  className="form-control"
                  id="pincode"
                  placeholder="Enter your pincode"
                  maxLength="6"
                  required
                  value={formData.pincode}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="address">
                  Address (Area and Street/House No.)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  placeholder="Enter your address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="locality">Locality</label>
                <input
                  type="text"
                  className="form-control"
                  id="locality"
                  placeholder="Enter your locality"
                  value={formData.locality}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="city">City</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  placeholder="Enter your city"
                  value={formData.city}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="state">State</label>
                <input
                  type="text"
                  className="form-control"
                  id="state"
                  placeholder="Enter your state"
                  value={formData.state}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="landmark">Landmark (optional)</label>
                <input
                  type="text"
                  className="form-control"
                  id="landmark"
                  placeholder="Enter a landmark"
                  value={formData.landmark}
                  onChange={handleChange}
                />
              </div>
              <div className=" col-lg-6">
                <label htmlFor="altPhoneNumber">
                  Alternative Phone Number (optional)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="altPhoneNumber"
                  placeholder="Alternative Phone Number"
                  value={formData.altPhoneNumber}
                  onChange={handleChange}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <input
                type="radio"
                id="savedAddresses"
                name="addressType"
                value="savedAddresses"
                checked={selectedAddress === "savedAddresses"}
                onChange={handleAddressChange}
              />
              <label htmlFor="savedAddresses">Saved Addresses</label>
            </div>
            <div>
              <input
                type="radio"
                id="savedInvoiceAddresses"
                name="addressType"
                value="savedInvoiceAddresses"
                checked={selectedAddress === "savedInvoiceAddresses"}
                onChange={handleAddressChange}
              />
              <label htmlFor="savedInvoiceAddresses">Billing Address</label>
            </div>
            <div className="row mt-2">
              <div className="col-lg-12">
                <div className="addressList-addressSegmentation">
                  <p>
                    <strong>DEFAULT ADDRESS</strong>
                  </p>
                </div>
              </div>
            </div>
            {loading ? (
              <ClipLoader loading size={15} />
            ) : !addressList?.length && selectedAddress == "savedAddresses" ? (
              <p>No Saved Address Added Yet!</p>
            ) : !addressList?.length &&
              selectedAddress == "savedInvoiceAddresses" ? (
              <p>No Billing Address Added Yet!</p>
            ) : (
              addressList?.map((item) => {
                return (
                  <>
                    <div className="address_box">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="addressAccordian-addressAccordian addressAccordian-myAddress">
                            {!item?.IsDefault ? (
                              <a
                                className="set_deft_address"
                                onClick={() =>
                                  UpdateDefaultDeliveryAddress(item)
                                }
                              >
                                Set As Default Address
                              </a>
                            ) : null}
                            <div className="address-card">
                              <p>{`${item?.PhoneNumber}, ${item?.AreaAndStreet} ${item?.Landmark} ${item?.City} ${item?.State} ${item?.Pincode}`}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <hr />
                        </div>
                        <div className="col-lg-6 col-6 add_text_center">
                          <input
                            type="button"
                            className="add_edit_remove_btn"
                            value="EDIT"
                            onClick={() => handleEditAddress(item)}
                          />
                        </div>
                        {selectedAddress == "savedAddresses" ? (
                          <div className="col-lg-6 col-6 add_text_center">
                            <input
                              type="button"
                              className="add_edit_remove_btn"
                              value="REMOVE"
                              onClick={() => handleRemoveAddress(item)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </>
                );
              })
            )}

            {/* <div className="row mt-2">
              <div className="col-lg-12">
                <div className="addressList-addressSegmentation"></div>
              </div>
            </div> */}
            {/* <div className="address_box">
              <div className="row">
                <div className="col-lg-12">
                  <div className="addressAccordian-addressAccordian addressAccordian-myAddress">
                    <a className="set_deft_address">Set As Default Address</a>
                    <div className="address-card">
                      <p>9356875721, 323223233 23223 23323 233223 233232 32332</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <hr />
                </div>
                <div className="col-lg-6 col-6 add_text_center">
                  <input type="button" className="add_edit_remove_btn" value="EDIT" />
                </div>
                <div className="col-lg-6 col-6 add_text_center">
                  <input type="button" className="add_edit_remove_btn" value="REMOVE" />
                </div>
              </div>
            </div> */}
          </>
        )}

        {addNew ? (
          <>
            <hr />
            <div className="row">
              <div className="col-lg-6">
                <button
                  type="button"
                  className="common_btn btn-primary form_go_btn"
                  onClick={() => {
                    setAddNew(false);
                    setFormData({
                      ...formData,
                      mobile: "",
                      pincode: "",
                      address: "",
                      locality: "",
                      city: "",
                      state: "",
                      landmark: "",
                      altPhoneNumber: "",
                    });
                  }}
                >
                  Go Back
                </button>
              </div>
              <div className="col-lg-6">
                <button
                  type="button"
                  className="common_btn view-data-btn form_save_btn"
                  onClick={() => handleSaveAddress()}
                >
                  Save
                </button>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default OrderAddressDetails;
